export const tcm = {
  dashboard: {
    dischargeStartDateLabel: 'Discharge Start Date',
    dischargeEndDateLabel: 'Discharge End Date'
  },
  adtQueue: {
    statusPending: 'Pending',
    statusInProgress: 'In Progress',
    statusProcessed: 'Processed',
    statusMissed: 'Missed',
    columns: {
      patientName: 'Patient Name',
      eventType: 'Event Type',
      facilityName: 'Facility Name',
      facilityType: 'Facility Type',
      readmissionRisk: 'Readmission Risk',
      dischargeDate: 'Discharge Date',
      dischargedDisposition: 'Discharged Disposition',
      admissionDate: 'Admission Date',
      admittedFrom: 'Admitted From',
      finalDueDate: 'Final Due Date',
      details: 'Details'
    },
    eventFilterLabel: 'Event',
    saveTemplateTitle: 'Save Template',
    nameRequiredMessage: 'Name field is required',
    noFiltersAddedMessage: 'No Filters have been added to save',
    filtersUpdatedMessage: 'Filters updated',
    filterTemplateRemovedMessage: 'Removed filter template'
  },
  dischargePatient: {
    searchRequiredMessage: 'One of the First Name, Last Name and Date of Birth is required',
    lookupFailedMessage: 'Lookup failed',
    notAllowedMessage: 'Request not allowed, logging out',
    genericErrorMessage: 'An error has occured',
    title: 'Discharge Patient',
    selectOptionPlaceholder: 'Select an option...',
    selectOptionPlaceholderNoDots: 'Select an option'
  },
  patientInfoDrawer: {
    profileHeading: 'Profile',
    dischargeSummaryHeading: 'Discharge Summary',
    truentityIdLabel: 'Truentity Id',
    phoneLabel: 'Phone',
    locationLabel: 'Location',
    dischargeDateLabel: 'Discharge Date',
    dischargingPhysicianLabel: 'Discharging Physician',
    dischargedDispositionLabel: 'Discharged Disposition',
    admittedFromLabel: 'Admitted From',
    admissionDateLabel: 'Admission Date',
    admissionReasonLabel: 'Admission Reason',
    primaryDiagnosisCodeLabel: 'Primary Diagnosis Code',
    primaryDiagnosisDescriptionLabel: 'Primary Diagnosis Description',
    readmissionRiskLabel: 'Readmission Risk',
    assignedToLabel: 'Assigned To'
  },
  dueDateFilters: {
    initialCommunicationLabel: 'Initial Communication due by',
    tcmFinalDueLabel: 'TCM Final due by',
    readmissionRiskLabel: 'Readmission Risk',
    selectOptionPlaceholder: 'Select an option...'
  }
} as const;
